import React, { useRef } from 'react';
import ImageIcon from '../../Dashboard/UserInfo/Modals/ImageIcon';
import '../../Dashboard/UserInfo/Modals/ImageIcon.css';
import { achievementFamily, achievementMotif } from './achievementVisual';
import AchievementArtV2 from './AchievementArtV2';
import './AchievementMark.css';

function iconType(familyOrTab) {
    if (familyOrTab === 'milestone' || familyOrTab === 'milestones') {
        return 'milestones';
    }
    if (familyOrTab === 'streak' || familyOrTab === 'streaks') {
        return 'streaks';
    }
    return 'badges';
}

/**
 * V2 achievement mark: V2 medallion first, legacy ImageIcon only as fallback.
 * Does not modify Assets/achievements or V1 ImageIcon behavior elsewhere.
 */
const AchievementMark = ({
    item,
    tabHint,
    goalsCompleted = 0,
    size = 88,
    earned = false,
}) => {
    const uidRef = useRef(`m${Math.random().toString(36).slice(2, 8)}`);
    const family = achievementFamily(item, tabHint);
    const motif = achievementMotif(item, family);
    const type = iconType(tabHint || family);
    const useV2 = Boolean(item);

    return (
        <span
            className={`dv2-am${earned ? ' is-earned' : ' is-locked'}`}
            data-motif={motif}
            data-family={family}
            style={{
                width: size,
                height: size,
                '--dv2-am-size': `${size}px`,
            }}
        >
            {earned ? <span className="dv2-am__glow" aria-hidden /> : null}
            <span className="dv2-am__art">
                {useV2 ? (
                    <AchievementArtV2
                        item={item}
                        tabHint={family}
                        goalsCompleted={goalsCompleted}
                        instanceId={uidRef.current}
                    />
                ) : (
                    <ImageIcon
                        achieved
                        name={item?.id}
                        type={type}
                        filename={item?.fileName}
                        item={item}
                        value={item?.achievementValue || goalsCompleted || 0}
                        index={0}
                    />
                )}
            </span>
            {!earned ? (
                <span className="dv2-am__lock" aria-hidden>
                    <svg viewBox="0 0 24 24" width="14" height="14">
                        <rect
                            x="6"
                            y="11"
                            width="12"
                            height="9"
                            rx="1.5"
                            fill="currentColor"
                        />
                        <path
                            d="M8 11 V8 a4 4 0 0 1 8 0 v3"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                        />
                    </svg>
                </span>
            ) : null}
        </span>
    );
};

export default AchievementMark;
